import React, { useEffect } from "react";
import lisenziya from "../img/licenziya.png";
import podderjka from "../img/podderjka.png";
import inteqrasiya from "../img/inteqrasiya.png";
import "./services.css";
import { useTranslation } from "react-i18next";

const Services = () => {
  const { t, i18n } = useTranslation();
  
    const changeLanguage = (lng) => {
      i18n.changeLanguage(lng);
      localStorage.setItem("lng", lng);
    };
  
    useEffect(() => {
      changeLanguage(localStorage.getItem("lng") || "en");
    }, []);

 

  return (
  <section className=" bg-gradient-to-r from-primary/100 to-primaryDark/70 backdrop-blur-lg  ">

   <div className="py-16 flex flex-col items-center px-4 sm:px-6 md:px-10">
      {/* Заголовок */}
      <div className="services-header mb-10 sm:mb-14 max-w-7xl w-full">
        <h1 className="text-center text-3xl sm:text-4xl md:text-5xl font-semibold text-white">
          {t("services_header")}
        </h1>
      </div>

      {/* Карточки */}
      <div className="grid grid-cols-1 gap-10 sm:grid-cols-1 lg:grid-cols-2 lg:grid-rows-2 xl:grid-cols-3 xl:grid-rows-1 max-w-5xl w-full  ">
        {/* Карточка 1 */}
        <div
          className="flex flex-col items-center text-center sm:text-white sm:hover:text-gray-500 bg-white sm:bg-white/30 sm:backdrop-blur-sm sm:hover:bg-white sm:shadow-lg p-6 rounded-lg transition-transform transform hover:scale-120 hover:-translate-y-2 sm:hover:shadow-2xl"
          
        >
          <div className="mb-4">
            <img
              className="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 object-contain "
              src={lisenziya}
              alt="Lisenziya"
            />
          </div>
          <h2 className="text-lg sm:text-xl md:text-2xl font-semibold mb-4">
            {t("services_card1_header")}
          </h2>
          <ul className="text-sm flex flex-col justify-start items-start sm:text-base text-start">
            <li>{t("services_card1_text1")}</li>
            <li>{t("services_card1_text2")}</li>
            <li>{t("services_card1_text3")}</li>
          </ul>
        </div>

        {/* Карточка 2 */}
        <div
          className="flex flex-col items-center text-center sm:text-white sm:hover:text-gray-500 bg-white sm:bg-white/30 sm:backdrop-blur-sm sm:hover:bg-white sm:shadow-lg p-6 rounded-lg transition-transform transform hover:scale-120 hover:-translate-y-2 sm:hover:shadow-2xl"
         
        >
          <div className="mb-4">
            <img
              className="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 object-contain "
              src={podderjka}
              alt="Podderjka"
            />
          </div>
          <h2 className="text-lg sm:text-xl md:text-2xl font-semibold mb-4">
            {t("services_card2_header")}
          </h2>
          <ul className="text-sm flex flex-col justify-start items-start sm:text-base text-start ">
            <li>{t("services_card2_text1")}</li>
            <li>{t("services_card2_text2")}</li>
          </ul>
        </div>

        {/* Карточка 3 */}
        <div
          className="flex flex-col items-center text-center sm:text-white sm:hover:text-gray-500 bg-white sm:bg-white/30 sm:backdrop-blur-sm sm:hover:bg-white sm:shadow-lg p-6 rounded-lg transition-transform transform hover:scale-120 hover:-translate-y-2 sm:hover:shadow-2xl"
          // data-aos="fade-up"
          // data-aos-delay="400"
        >
          <div className="mb-4">
            <img
              className="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 object-contain "
              src={inteqrasiya}
              alt="İnteqrasiya"
            />
          </div>
          <h2 className="text-lg sm:text-xl md:text-2xl font-semibold mb-4">
            {t("services_card3_header")}
          </h2>
          <ul className="text-sm flex flex-col justify-start items-start sm:text-base text-start">
            <li>{t("services_card3_text1")}</li>
            {/* <li>{t("services_card3_text2")}</li> */}
          </ul>
        </div>
      </div>
    </div>
  </section>
  );
};

export default Services;
